import { render, staticRenderFns } from "./ManageSendValidation.vue?vue&type=template&id=df06f31c&scoped=true"
import script from "./ManageSendValidation.vue?vue&type=script&lang=js"
export * from "./ManageSendValidation.vue?vue&type=script&lang=js"
import style0 from "./ManageSendValidation.vue?vue&type=style&index=0&id=df06f31c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df06f31c",
  null
  
)

export default component.exports